import _classCallCheck from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.function.name.js";
import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { UserModule } from '@/store/modules/user';
import Account from './components/Account.vue';
import Activity from './components/Activity.vue';
import Timeline from './components/Timeline.vue';
import UserCard from './components/UserCard.vue';
var defaultProfile = {
  name: 'Loading...',
  email: 'Loading...',
  avatar: 'Loading...',
  roles: 'Loading...'
};
var default_1 = /*#__PURE__*/function (_Vue) {
  function default_1() {
    var _this;
    _classCallCheck(this, default_1);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, default_1, [].concat(args));
    _defineProperty(_this, "user", defaultProfile);
    _defineProperty(_this, "activeTab", 'activity');
    return _this;
  }
  _inherits(default_1, _Vue);
  return _createClass(default_1, [{
    key: "name",
    get: function get() {
      return UserModule.name;
    }
  }, {
    key: "email",
    get: function get() {
      return UserModule.email;
    }
  }, {
    key: "avatar",
    get: function get() {
      return UserModule.avatar;
    }
  }, {
    key: "roles",
    get: function get() {
      return UserModule.roles;
    }
  }, {
    key: "created",
    value: function created() {
      this.getUser();
    }
  }, {
    key: "getUser",
    value: function getUser() {
      this.user = {
        name: this.name,
        email: this.email,
        avatar: this.avatar,
        roles: this.roles.join(' | ')
      };
    }
  }]);
}(Vue);
default_1 = __decorate([Component({
  name: 'Profile',
  components: {
    Account: Account,
    Activity: Activity,
    Timeline: Timeline,
    UserCard: UserCard
  }
})], default_1);
export default default_1;